import {
  FormControl,
  OutlinedInput,
  InputLabel,
  FormHelperText,
  Box,
  Typography,
} from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

const Input = ({
  id,
  label,
  value,
  onChange,
  fullwidth,
  width,
  type,
  multiline,
  message,
  error,
  required,
  disabled,
  endAdornment,
  maxLength = null,
  showLength = null,
}) => {
  const { getMessage, getLabel } = useLocalization();

  const handleChange = (newValue) => {
    // If maxLength is set, prevent adding characters beyond the limit
    if (maxLength && newValue.length > maxLength) {
      return;
    }
    onChange(newValue);
  };

  return (
    <Box>
      <Box sx={{ paddingLeft: "6px", paddingRight: "6px" }}>
        <Typography sx={{ fontSize: "10px", fontWeight: "bold" }}>
          {getLabel(label)}
        </Typography>
      </Box>

      <FormControl
        id={id}
        fullWidth={fullwidth}
        sx={{
          width: width,
        }}
        size="small"
      >
        <OutlinedInput
          id={id}
          value={value || ""}
          error={error || false}
          onChange={(e) => handleChange(e.target.value)}
          type={type || "text"}
          multiline={multiline}
          width={width}
          required={required}
          size="small"
          autoComplete="new-password"
          inputProps={{
            autoComplete: "new-password",
            form: {
              autoComplete: "off",
            },
            maxLength: maxLength || undefined,
          }}
          disabled={disabled}
          fullWidth={fullwidth}
          sx={{ fontSize: "12px" }}
          endAdornment={endAdornment}
        />

        <FormHelperText error={error || false}>
          {getMessage(message) || ""}
        </FormHelperText>

        {showLength && (
          <Typography
            sx={{
              fontSize: "9px",
              color: "#999",
              marginTop: "4px",
              textAlign: "right",
            }}
          >
            {value?.length || 0}
            {maxLength ? `/${maxLength}` : ""} characters
          </Typography>
        )}
      </FormControl>
    </Box>
  );
};

export default Input;
